module.exports = __webpack_public_path__ + "static/media/alert-programming.970dff71.svg";